import React from 'react';
import Classnames from 'classnames';
import Sizeable from "react-sizeable";
import { connect } from 'react-redux';

import FundInput from '../FundInput';
import CompositionTable from '../components/CompositionTable';
import EditableName from '../components/EditableName';

import { normalized } from '../selectors/normalized-weights';

import './style.css';

const Component = props => {
  const {
    portfolio,
    inFocus,
    side,
    portfolioName,
    portfolioEmail,
    weightingSchemes,
    fixedWeighting,
    width,
    clientEmail,
    TEXT,
    featuresEditPortfolioName,
  } = props;

  const {
    setFocusPortfolio,
    addFilteredFunds,
    removeFundAtIndex,
    setWeighting,
    setPercentageWeighting,
    unsetPercentageWeighting,
    setPortfolioName,
    setPortfolioEmail,
    setFixedWeighting,
  } = props;

  const addFunds = funds => {
    addFilteredFunds(
      funds.filter(f => 
        f && portfolio
          .map(p => p.ticker)
          .indexOf(f.ticker) === -1))
  }

  const showEmail = clientEmail.substring(clientEmail.length - 14) === 'wisdomtree.com';

  return (
    <div className={Classnames("portfolio-configuration", !inFocus && "out-of-focus")}>
      <div className="click-to-edit">
          <button onClick={() => setFocusPortfolio(side)}></button>
      </div>
      { featuresEditPortfolioName ? <EditableName TEXT={TEXT} value={portfolioName} onChange={setPortfolioName} version="name" side={side} /> : null }
      { showEmail && side === "original" && featuresEditPortfolioName ? <EditableName TEXT={TEXT} value={portfolioEmail} onChange={setPortfolioEmail} version="email" side={side} /> : null }
      
      <FundInput
        key={portfolio.length}
        side={side}
        onSelect={addFunds}
        placeholder={TEXT.searchBoxLabel}
        suggestionToString={d => d.ticker}
        width={props.width}
      >
        {suggestion => (
          <span>
            <span className="ticker">{suggestion.ticker}</span>
            <span className="name">{suggestion.name}</span>
          </span>
        )}
      </FundInput>

      {!portfolio.length
        ? null
        : <Sizeable>
            <CompositionTable
              TEXT={TEXT}
              rows={portfolio}
              weightingSchemes={weightingSchemes}
              fixedWeighting={fixedWeighting}
              setFixedWeighting={setFixedWeighting}
              removeIndex={removeFundAtIndex}
              setWeighting={setWeighting}
              setPercentageWeighting={setPercentageWeighting}
              unsetPercentageWeighting={unsetPercentageWeighting}
              width={width}
            />
          </Sizeable>}


    </div>
  );
};

const weightingSchemes = (state, ownProps) => ({
  weightings: state.entry[ownProps.side].weightings,
  normalized: normalized(state)[ownProps.side],
  percentage: state.percentageWeightings[ownProps.side],
  preexisting: state.preexistingWeightings[ownProps.side],
});

const mapStateToProps = (state, ownProps) => ({
  loading: state.loading,
  analysis: state.analysis,
  portfolioName: state.entry[ownProps.side].name,
  portfolioEmail: state.entry[ownProps.side].preparedForEmail,
  portfolio: state.entry[ownProps.side].portfolio,
  weightingSchemes: weightingSchemes(state, ownProps),
  fixedWeighting: state.fixedWeighting[ownProps.side],
  clientEmail: state.clientEmail,
  TEXT: state.complianceText,
  usingModel: state.entry[ownProps.side].usingModel,
  featuresEditPortfolioName: state.features.editPortfolioName,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  setFocusPortfolio(portfolio){
    dispatch({ type: 'SET_FOCUS_PORTFOLIO', portfolio });
  },

  addFilteredFunds(funds) {
    dispatch({ type: 'ADD_FUNDS', funds, side: ownProps.side });
  },
  removeFundAtIndex(index) {
    dispatch({ type: 'REMOVE_FUND', index, side: ownProps.side });
  },

  setWeighting(key, weighting, method) {
    if (method === 'input') {
      dispatch({ type: 'SET_WEIGHTING', key, weighting, side: ownProps.side, specified: true});
    } else if (method === 'drag') {
      dispatch({ type: 'SET_WEIGHTING', key, weighting, side: ownProps.side, tentative: true });
    } else {
      dispatch({ type: 'SET_WEIGHTING', key, weighting, side: ownProps.side });
    }
  },
  setPercentageWeighting(key, weighting) {
    dispatch({ type: 'SET_PERCENTAGE_WEIGHTING', key, weighting, side: ownProps.side });
  },
  unsetPercentageWeighting(key) {
    dispatch({ type: 'SET_PERCENTAGE_WEIGHTING', key, weighting: null, side: ownProps.side });
  },

  setPortfolioName(name) {
    dispatch({ type: 'SET_PORTFOLIO_NAME', name, side: ownProps.side });
  },
  setPortfolioEmail(email) {
    dispatch({ type: 'SET_PORTFOLIO_EMAIL', email });
  },
  setFixedWeighting(value) {
    dispatch({ type: 'SET_FIXED_WEIGHTING', value, side: ownProps.side });
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/Entry/PortfolioConfiguration.js